import { ISchedule } from '../services/schedule/schedule.model'

/** Where schedules are paused, edited and deleted. */
export const SCHEDULES_LINK = '/settings/company-settings/schedules'

/**
 * A sync an integration page hands to the Financial page to run. The page runs it exactly as its
 * own Sync Data button would (same request, same "Syncing Data" state, same coverage message), so
 * the user lands on the review tab and watches the records arrive.
 */
export interface ILedgerSyncRequest {
  provider: string;
  companyId: string;
  /** YYYY-MM-DD to read again from; null continues from the last sync. */
  syncFrom: string | null;
}

/** The Financial page's review tab, filtered to one integration, with the sync to start on arrival. */
export const ledgerSyncNavigation = (request: ILedgerSyncRequest): { to: string, state: { startSync: ILedgerSyncRequest } } => ({
  to: `/emissions/financial?tabId=0&integration=${encodeURIComponent(request.provider)}`,
  state: { startSync: request },
})

/**
 * Whether an active schedule already syncs one of these ledgers. Active means the schedule is on
 * with a run still to come and the sync action itself is on; a paused schedule or a switched-off
 * action does not count, so the Financial page offers to schedule again rather than to manage.
 */
export const hasActiveAccountingSchedule = (schedules: ISchedule[] | undefined, providerCodes: string[]): boolean =>
  (schedules || []).some(schedule =>
    schedule.active && !!schedule.nextRunAt && (schedule.scheduleActions || []).some(action =>
      action.active
      && action.actionType === 'sync_accounting'
      && providerCodes.includes(String((action.actionPayload as any)?.provider || '')),
    ),
  )
